module.exports = __webpack_public_path__ + "img/key-fill-purple.4e472b8b.svg";